import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { textOverflowDots } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    mainWrapper: {
        width: 'clamp(240px, 20%, 320px)',
        flexShrink: 0,
        height: '100%',
        backgroundColor: theme.colors.grey_background,
        boxShadow: '4px 0 12px 0 rgba(115, 115, 115, 0.12)',
    },
    sideBarContent: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
    },
    headerWraper: {
        width: '100%',
        height: '80px',
        borderBottom: `2px solid ${theme.colors.grey_light}`,
        display: 'flex',
        alignItems: 'center',
        padding: 15,

        '& img':{
            marginRight: theme.spacing(2),
            width: 30,
            height: 30,

            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },
    userAvatar: {
        display: 'inline-flex',
        marginRight: theme.spacing(3),
        [theme.down('desktop')]: {
            display: 'none',
        },
    },

    procedureAvatar: {
        flexShrink: 0,
        width: 36,
        height: 36,
        borderRadius: theme.radius,
        overflow: 'hidden',
        marginRight: theme.spacing(2),
        background: theme.colors.grey_light,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.down('desktop')]: {
            display: 'none',
        },
    },

    procedureAvatarImg: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        margin: '0 !important',
        '&:hover': { backgroundColor: 'transparent !important' },
    },

    procedureAvatarPlaceholder: {
        width: '20px !important',
        height: '20px !important',
        margin: '0 !important',
        opacity: 0.45,
        filter: theme.isDark ? 'brightness(0) invert(0.7)' : 'none',
        '&:hover': { backgroundColor: 'transparent !important' },
    },
    fullNameContaier: {
        fontSize: 18,
        fontWeight: '700',
        fontFamily: theme.font.secondary,
        color: theme.colors.black,
        flex: '1 1 0',
        minWidth: 0,
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
    },

    insightsBtn: {
        flexShrink: 0,
        marginLeft: theme.spacing(1.5),
        border: `1.5px solid ${theme.colors.violet_primary}`,
        borderRadius: 999,
        background: 'transparent',
        color: theme.colors.violet_primary,
        fontFamily: theme.font.secondary,
        fontSize: 11,
        fontWeight: 700,
        padding: `4px 12px`,
        cursor: 'pointer',
        letterSpacing: '0.04em',
        transition: 'background 140ms ease, color 140ms ease',
        whiteSpace: 'nowrap',
        '&:hover': {
            background: theme.colors.transp_violet,
        },
    },
    headerLabel:{
        display: 'flex',
        alignItems: 'center',

        '& img': {
            marginRight: theme.spacing(2),
            height: 24,
            width: 24,
            filter: theme.isDark ? 'brightness(0) invert(0.8)' : 'none',
        },
    },

    groupsWrapper: {
        width: '100%',
        borderBottom: `2px solid ${theme.colors.grey_light}`,
        flex: '0 0 auto',
        overflow: 'hidden',
    },
    groupsHeader: {
        height: '50px',
        padding: `10px 20px`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        '& img': {
            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },
    groupsContainer:{
        minHeight: '24px',
        maxHeight: '140px',
        margin: '16px 20px 20px 20px',
        display: 'flex',
        flexFlow: 'row',
        flexWrap: 'wrap',
        columnGap: '10px',
        rowGap: '10px',
        alignItems: 'center',
        justifyContent: 'start',
        overflowY: 'auto',
    },
    groupContainer: {
        height: '30px',
        borderRadius: theme.radius,
        backgroundColor: theme.colors.transp_violet,
        padding:  5,

        '&:hover':{
            backgroundColor: theme.colors.transp_blue_darker,
        },
    },
    passiveGroupContainer: {
        display: 'inline-flex',
        alignItems: 'center',
        minHeight: '30px',
        borderRadius: theme.radius,
        backgroundColor: theme.colors.transp_violet,
        padding: `5px ${theme.spacing(2)}`,
    },
    groupLabel: {
        margin: '0px 10px',
        fontFamily: theme.font.secondary,
        fontSize: 14,
        color: theme.colors.black,
    },
    actorFilterButton: {
        width: '100% !important',
        maxWidth: 'none !important',
        minHeight: 42,
        padding: `${theme.spacing(1.5)} ${theme.spacing(2)} !important`,
        borderRadius: theme.radius,
        backgroundColor: theme.colors.transp_violet,
        fontFamily: theme.font.secondary,
        justifyContent: 'space-between',
        textAlign: 'left',
    },
    actorFilterContent: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        minWidth: 0,
    },
    actorFilterLabel: {
        ...textOverflowDots(),
        fontFamily: theme.font.secondary,
        fontSize: 14,
        fontWeight: 600,
    },
    actorFilterCount: {
        color: theme.colors.grey_text,
        fontFamily: theme.font.secondary,
        fontSize: 12,
        whiteSpace: 'nowrap',
    },
    groupFilterButton: {
        width: 'auto !important',
        maxWidth: 'none !important',
        minHeight: 32,
        padding: `0 ${theme.spacing(2)} !important`,
        borderRadius: 999,
        backgroundColor: theme.colors.transp_violet,
        fontFamily: theme.font.secondary,
        fontSize: 14,
        lineHeight: 1.2,
    },
    placeholderText: {
        padding: `0 ${theme.spacing(2)}`,
        color: theme.colors.grey_text,
        fontFamily: theme.font.secondary,
        fontStyle: 'italic',
    },

    proceduresWrapper: {
        width: '100%',
        flex: 1,
        minHeight: 0,
        borderBottom: `2px solid ${theme.colors.grey_light}`,
        overflow: 'hidden',
    },
    proceduresHeader: {
        height: '50px',
        padding: `10px 20px`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        '& img': {
            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },
    proceduresContainer:{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: theme.spacing(1),
    },
    proceduresScroller: {
        maxHeight: '600px',
        minHeight: 0,
        overflowY: 'auto',
        paddingBottom: theme.spacing(3),
    },
    procedureContainer:{
        height: '50px',
        maxWidth: '100% !important',
        padding: `${theme.spacing(2)} !important`,
        alignContent: 'center',
        alignItems: 'center',
    },
    procedureLabel:{
        marginLeft: '20px',
        fontFamily: theme.font.secondary,
    },

    competenciesWrapper: {
        width: '100%',
        maxHeight: 'calc(50% - 90px)',
        borderBottom: `2px solid ${theme.colors.grey_light}`,
    },
    competenciesHeader: {
        height: '50px',
        padding: `10px 20px`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        '& img': {
            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },
}));